import { create } from "zustand";

const initialState = {
  selectedProduct: null,
  warrantyState: undefined,
  isDiscountApplied: false,
  discountCode: undefined,
  variants: null,
  paypalHandler: "standart",
  cartTotal: "0.00",
};

export const useCartData = create((set, get) => ({
  ...initialState,
  setSelectedProduct: (payload) => set((state) => ({ ...state, selectedProduct: payload })),
  setWarrantyState: (warrantyState) => set((state) => ({ ...state, warrantyState: warrantyState })),
  handleSetDiscountCode: (discountCode) =>
    set((state) => ({ ...state, discountCode: discountCode, isDiscountApplied: true })),
  handleRemoveDiscountCode: () => set((state) => ({ ...state, discountCode: undefined, isDiscountApplied: false })),
  setPaypalHandler: (payload) => set((state) => ({ ...state, paypalHandler: payload })),
  setVariants: (payload) => set((state) => ({ ...state, ...payload })),
  setCartTotal: (val) =>
    set((state) => ({ ...state, cartTotal: typeof val === "number" ? val.toFixed(2) : String(val) })),
}));
